export const ENDPOINTS = {
    search: "/shipment/guest-account/search",
    saveGuestDetails: "/shipment/guest-account/save",
    getGuestDetails: "/shipment/guest-account/details",
    updateGuestDetails: "/shipment/guest-account/update",
    deleteGuestDetails: "/shipment/guest-account/delete",
    getAllProductsForGuestNAR: "/guestaccount/getAllproductsForGuestNAR",
    getAllproductsrelatedNavDb: "/guestaccount/getAllproductsrelatedNavDb",
    guestAccountEmail:"guest-account/send-email",
    downloadTracking: "inds/downloadTracking",
    customerDetails: "customer/customers/basic/listing",
    contactAdmin: {
        roleType: "/roles/type",
        createUser: "/inds/associate-honeywellid-customer",
        createContact: "/inds/create-contact",
        fullName: "inds/full-names",
        companies: "inds/companies",
        customerNumbers: "/inds/customer-numbers",
        honeywellIds: "/inds/honeywell-ids",
        tailNumbers: "/inds/tail-numbers",
        serialNumbers: "/inds/serial-numbers",
        contactSearch: "/user/contact/search",
        editContactAdmin: "user/contact-admin/view",
        updateUser: "/users/update",
        deAssociateUser:"/users/de-associate",
        validateRole:"inds/validate-user-association-role",
        customerUsersSearch:"/users/sso/details"

    },
    operatorAdmin: {
        operatorAdminView: "/user/operator-admin/view",
         operatorAdminStatus: "/users/update/status"
    },
    indsShare: {
        getAllDetails: "/file/share/getAllDetails",
        fileShareDelete: "/file/share/delete",
        DOWNLOAD_FILE_SHARE_DETAILS: "/file/share/download",
        FILE_SHARE_ADD_NEW_DOC: "/file/share/addNewDocument",
        getAllFileTypesAndSubTypes: "/file/share/getAllFileTypesAndSubTypes"
    },
    reports:{
        viewReports:"/view-reports",
        generateReports:"/view-reports/generate"
    }
};